import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Clock } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencySection() {
  const {
    minutes,
    seconds,
    isExpired
  } = useCountdown();
  return <section className="py-20 bg-[#E63946] text-white relative overflow-hidden" data-id="element-468">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10" data-id="element-469"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-470">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-471">
          <h2 className="text-3xl md:text-4xl font-black mb-8" data-id="element-472">
            El precio de lanzamiento termina en:
          </h2>

          <div className="flex justify-center items-center gap-4 mb-8" data-id="element-473">
            <div className="bg-white text-[#E63946] rounded-2xl p-6 shadow-2xl min-w-[160px]" data-id="element-474">
              <div className="text-6xl md:text-7xl font-black font-mono tracking-tighter" data-id="element-475">
                {!isExpired ? `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}` : '00:00'}
              </div>
            </div>
          </div>

          <div className="space-y-2 mb-10 text-lg font-medium text-red-100" data-id="element-476">
            <p data-id="element-477">Cuando llegue a cero, el precio promocional desaparecerá.</p>
            <p className="text-white font-bold text-xl mt-4" data-id="element-478">
              Quedan pocos accesos disponibles al precio actual.
            </p>
          </div>

          <a href="https://pay.hotmart.com/J104331849I?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-[#16A34A] hover:bg-[#15803D] text-white font-black text-xl md:text-2xl py-5 px-10 rounded-full shadow-[0_0_30px_rgba(22,163,74,0.4)] hover:shadow-[0_0_40px_rgba(22,163,74,0.6)] transform hover:scale-105 transition-all duration-300 w-full md:w-auto" data-id="element-479">
            ASEGURAR MI ACCESO AHORA
            <ArrowRight className="w-6 h-6" data-id="element-480" />
          </a>
        </motion.div>
      </div>
    </section>;
}